import jQuery from "jquery";
import { addSearchQuery, getPathFromUrl } from "../utils/utils";

jQuery(function () {
  "use strict";

  addSearchQuery();

  jQuery("#leeren").on("click", reset_form);

  function reset_form() {
    window.location = getPathFromUrl(window.location.href);
    document.getElementById("pubdatenbank").reset();
  }
});
